class CustomSellingPlan extends HTMLElement {
    constructor() {
        super();
    }
    
    connectedCallback() {
        this.sellingID = this.dataset.plan;
        this.variantID = this.dataset.variant;
        this.form = document.querySelector(`form[id='${this.dataset.productFormId}']`);
        this.sellingPlanInput = this.form.querySelector("input[name='selling_plan']");
        this.variantIdInput = this.form.querySelector("input[name='id']");
        this.addSellingPlanInput();
        this.buyButtonContent = this.form.querySelector("buy-buttons > button > div");
        this.priceType = this.dataset.reducedPrice === "true" ? "compare" : "normal";

        this.addEventListener("click", () => {
            this.setSellingPlan();
            changeSelectedPlan(this.dataset.productFormId, this);
        });

        addSellingPlanToGroup(this.dataset.productFormId, this);
    }

    addSellingPlanInput(){
        if(this.sellingPlanInput){
        } else {
            let input = document.createElement("input");
            input.name = 'selling_plan';
            input.type = 'hidden';
    
    
            this.form.insertBefore(input, this.form.firstChild);
            this.sellingPlanInput = this.form.querySelector("input[name='selling_plan']");
        }
    }

    changeBuyButtonPrice(){
        let newPrice = `${this.buyButtonContent.textContent.split("|")[0]}|`;
        if(this.priceType == "compare"){
            newPrice = newPrice.concat(`
                <span class="product-price">
                    <span class="compare-at-price">${this.dataset.slashedPrice}</span>
                    <span class="current-price">${this.dataset.normalPrice}</span>
                </span>`)
        } else {
            newPrice = newPrice.concat(`<span style="padding-left: 5px;" class="product-price">${this.dataset.normalPrice}</span>`)
        }
        this.buyButtonContent.innerHTML = newPrice;
    }

    setSellingPlan(){
        this.variantIdInput.value = this.variantID;
        this.sellingPlanInput.value = this.sellingID;
    }
}

customElements.define('custom-selling-plan', CustomSellingPlan)